import useSwr from 'swr';
import CompanyDeviceUpdateStatus from '../models/CompanyDeviceUpdateStatus';
import companyDeviceUpdatesService from '../services/CompanyDeviceUpdatesService';

export default function useCompanyDeviceUpdateStatus(): { data?: CompanyDeviceUpdateStatus[]; error?: Error } {
  return useSwr(
    ['CompanyDeviceUpdatesService', 'getDeviceUpdateStatus'],
    () => companyDeviceUpdatesService.getDeviceUpdateStatus(),
    { refreshInterval: 120000 }
  );
}
